import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';

import ItemCardShortDate from '@/components/GridItemCard/Card/components/ItemCardShortDate/ItemCardShortDate';
import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryBuyNowAvailable,
    getItemSummaryIsLocked,
    getItemSummaryIsPassed,
    getItemSummaryIsSold,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { getLiveItemStatusOpen } from '@/redux/modules/liveItemStatus';
import { ItemCardNavigationTrigger } from '@/utils/amplitude/analytics';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export type CardInfoProps = {
    className?: string;
    hasNewSimilarItemsIconCTA?: boolean;
    itemId: number;
    onNavigate?: (trigger: ItemCardNavigationTrigger) => void;
};

export const CardInfo = ({ className, hasNewSimilarItemsIconCTA = false, itemId, onNavigate }: CardInfoProps) => {
    const formatMessage = useAppFormatMessage();
    const buyNowAvailable = useAppSelector((state) => getItemSummaryBuyNowAvailable(state, itemId));
    const isLotOpen = useAppSelector((state) => getLiveItemStatusOpen(state, itemId));
    const isPassed = useAppSelector((state) => getItemSummaryIsPassed(state, itemId));
    const isSold = useAppSelector((state) => getItemSummaryIsSold(state, itemId));
    const isLocked = useAppSelector((state) => getItemSummaryIsLocked(state, itemId));
    const isPending = isLocked && !isPassed && !isSold && !isLotOpen;

    // Displays Card Info in item cards (not Timed Plus) on Category and Search Pages.
    return (
        <section className="flex items-center justify-between gap-xs [grid-area:iteminfo]">
            <span className="max-[375px]:w-auto leading-[18px] xsMax:w-full xsMax:whitespace-nowrap">
                {buyNowAvailable ? (
                    <BodySecondary
                        className={className}
                        color="secondary"
                    >
                        {formatMessage(['buy_now'])}
                    </BodySecondary>
                ) : (
                    <ItemCardShortDate
                        className={className}
                        hasNewSimilarItemsIconCTA={hasNewSimilarItemsIconCTA}
                        itemId={itemId}
                        onNavigate={onNavigate}
                        showOnlyYear={isSold || isPassed || isPending}
                    />
                )}
            </span>
        </section>
    );
};
